import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Flame } from "lucide-react";

export const ChallengeDialog = ({ open, onOpenChange, form, onFormChange, onSubmit, submitting, memberCount }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="rounded-3xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="font-display flex items-center gap-2">
          <Flame className="w-5 h-5 text-orange-500" />
          Nouveau défi équipe
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-3 mt-2">
        <div>
          <Label className="text-xs font-semibold">Titre du défi</Label>
          <Input value={form.title} onChange={(e) => onFormChange({ ...form, title: e.target.value })} className="rounded-2xl mt-1 h-11" data-testid="challenge-title" placeholder="Ex: 10 appels vers syndics IDF" />
        </div>
        <div>
          <Label className="text-xs font-semibold">Description (optionnel)</Label>
          <Textarea rows={2} value={form.description} onChange={(e) => onFormChange({ ...form, description: e.target.value })} className="rounded-2xl mt-1" data-testid="challenge-desc" placeholder="Précisez le contexte ou la méthode attendue" />
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-xs font-semibold">Canal</Label>
            <Select value={form.channel} onValueChange={(v) => onFormChange({ ...form, channel: v })}>
              <SelectTrigger className="rounded-2xl mt-1 h-11" data-testid="challenge-channel"><SelectValue /></SelectTrigger>
              <SelectContent>
                {["Road Maps", "Téléphone", "LinkedIn", "Email", "Mix"].map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs font-semibold">Points XP</Label>
            <Input type="number" value={form.xp} onChange={(e) => onFormChange({ ...form, xp: Number(e.target.value) })} className="rounded-2xl mt-1 h-11" min="10" step="10" data-testid="challenge-xp" />
          </div>
        </div>
        <Button onClick={onSubmit} disabled={submitting || !form.title} className="w-full rounded-full bg-gradient-to-br from-emerald-500 to-orange-500 h-12 font-semibold mt-2" data-testid="challenge-confirm-create">
          {submitting ? "Envoi..." : `Envoyer à ${memberCount} membres`}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
